import $ from 'gridstrap/lib/gs-zepto';


export class GSHeaderMenuTray {

	//
	// Properties
	//

	private root;
	private divider;
	private sections;

	private closeTimer;
	private currentSection;
	private events: any = {};

	//
	// Methods
	//

	toggle(id) {
		this.currentSection === id
			? this.close()
			: this.open(id)
		;
	}

	open(id) {
		this.reset();
		this.currentSection = id;
		this.root.get(0).scrollTop = 0;

		if (!this.root.hasClass('gs-HeaderMenuTray--open')) {
			this.root
				.addClass('gs-HeaderMenuTray--animating')
				.one('transitionend', () => this.root.removeClass('gs-HeaderMenuTray--animating'))
				.addClass('gs-HeaderMenuTray--open');
			this.divider
				.addClass('gs-HeaderMenuTray-divider--open');
		}

		this.sections
			.removeClass('gs-HeaderMenuTray-section--open')
			.filter(`#gs-HeaderMenuTray--${id}`)
			.addClass('gs-HeaderMenuTray-section--open');

		this.trigger('open', id);
	}

	close() {
		this.reset();
		this.currentSection = undefined;

		this.closeTimer = setTimeout(() => {
			this.root
				.addClass('gs-HeaderMenuTray--animating')
				.one('transitionend', () => this.root.removeClass('gs-HeaderMenuTray--animating'))
				.removeClass('gs-HeaderMenuTray--open');

			this.divider
				.removeClass('gs-HeaderMenuTray-divider--open');

			this.trigger('close');
		}, 75);
	}

	reset() {
		clearTimeout(this.closeTimer);
	}

	on(name, fn) {
		this.events[name] ??= [];
		this.events[name].push(fn);
	}

	private trigger(name, params?) {
		this.events[name]?.forEach((fn) => fn(params));
	}

	//
	// Initialization
	//

	constructor(root) {
		this.root = $(root);
		this.divider = $('body').find('.gs-HeaderMenuTray-divider');
		this.sections = this.root.find('.gs-HeaderMenuTray-section');
	}

	gsOnInit() {
		this.root.on('mouseenter', () => this.reset());
		this.root.on('mouseleave', () => this.close());
	}
}
